<template>
  <div
    v-if="
      props.isSupplyOrganization &&
      props.deal?.isPreferredOrNGInternalDeal &&
      props.deal?.curatorOrganizationIDs?.length === 0
    "
    class="col-12 col-lg-12">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><IconColoredCPM /></span>
          <span>{{ capitalize($t('names.cpm', { n: 1 })) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content pad-top">
          <div class="row">
            <div class="col-12">
              <span
                id="package_details_cpm"
                class="text-muted money"
                >{{ props.deal.cpmCalculator.cpmDescription }}</span
              >
              <input
                id="package_details_cpm_fixed_value"
                type="hidden"
                :value="props.deal.cpmFixed" />
              <input
                id="package_details_cpm_from_rate_card_value"
                type="hidden"
                :value="props.deal.isCPMFromRateCard" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    :class="{ 'col-12': !isNGExternalOrPreferredExternalDeal, 'col-lg-6': isNGExternalOrPreferredExternalDeal }">
    <div class="row">
      <div class="col-12">
        <div class="pane-header">
          <span class="icon"><icon-colored-budget /></span>
          <span>{{ capitalize($t('names.budget', { n: 1 })) }}</span>
        </div>
      </div>
      <div class="col-12">
        <div class="pane-content">
          <div class="row">
            <div
              v-if="!isNGExternalOrPreferredExternalDeal && !isNGDeal"
              class="col-12 col-lg-4">
              <h4>{{ capitalize($t('names.impression', { n: 2 })) }}</h4>
              <span
                id="package_details_impressions"
                class="text-muted"
                >{{ props.deal.impressionsDescription }}</span
              >
              <input
                id="package_details_market_target_impressions_min_value"
                type="hidden"
                :value="props.deal.marketTargetedImpressionsMin" />
              <input
                id="package_details_market_target_impressions_max_value"
                type="hidden"
                :value="props.deal.marketTargetedImpressionsMax" />
              <input
                id="package_details_market_target_impressions_overridable_value"
                type="hidden"
                :value="props.deal.marketTargetedImpressionsOverridable" />
            </div>
            <div
              v-if="!isNGExternalOrPreferredExternalDeal && !isNGDeal"
              class="col-12 col-lg-4">
              <h4>{{ capitalize($t('names.budget', { n: 1 })) }}</h4>
              <span
                id="package_details_budget"
                class="text-muted money"
                >{{ props.deal.budgetDescription }}</span
              >
              <input
                id="package_details_budget_min_value"
                type="hidden"
                :value="props.deal.budgetMin" />
              <input
                id="package_details_budget_max_value"
                type="hidden"
                :value="props.deal.budgetMax" />
              <input
                id="package_details_budget_overridable_value"
                type="hidden"
                :value="props.deal.budgetOverridable" />
              <input
                id="package_details_impressions_min_value"
                type="hidden"
                :value="props.deal.marketTargetedImpressionsMin" />
              <input
                id="package_details_impressions_max_value"
                type="hidden"
                :value="props.deal.marketTargetedImpressionsMax" />
              <input
                id="package_details_impressions_overridable_value"
                type="hidden"
                :value="props.deal.marketTargetedImpressionsOverridable" />
            </div>
            <div class="col-12 col-lg-4">
              <h4>{{ capitalize($t('names.cpm', { n: 1 })) }}</h4>
              <span
                id="package_details_cpm"
                class="text-muted money"
                >{{ props.deal.cpmCalculator.cpmDescription }}</span
              >
              <input
                id="package_details_cpm_fixed_value"
                type="hidden"
                :value="props.deal.cpmFixed" />
              <input
                id="package_details_cpm_from_rate_card_value"
                type="hidden"
                :value="props.deal.isCPMFromRateCard" />
            </div>
            <div
              v-if="props.deal.purchaseType === PurchaseTypes.CADENCE"
              class="col-12 col-lg-6">
              <h4>{{ capitalize($t('names.cadence', { n: 1 })) }}</h4>
              <span
                class="text-muted"
                v-text="props.deal.cadenceMin" />
              <span class="text-muted">/ {{ $t('names.hour', { n: 1 }) }}</span
              ><br />
            </div>
            <div
              v-if="isNGExternalOrPreferredExternalDeal && (isSupplyOrganization || isCuratorOrganization)"
              class="col-12 col-lg-4">
              <h4>{{ capitalize($t('names.auctionType', { n: 1 })) }}</h4>
              <span
                class="text-muted"
                v-text="props.deal.auctionTypeFormatted" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { capitalize } from 'vue';

  import PurchaseTypes from '@/common/enums/purchase-types.enum';
  import { IconColoredBudget, IconColoredCPM } from '@/common/icons/colored';
  import { Package } from '@/common/models';

  interface IDealDetailsBudget {
    deal: Package;
    isSupplyOrganization: boolean;
    isCuratorOrganization: boolean;
    isNGDeal: boolean;
    isNGExternalOrPreferredExternalDeal: boolean;
  }

  const props = defineProps<IDealDetailsBudget>();
</script>

<style lang="scss" scoped>
  @use '@/styles/variables.scss' as *;
</style>
